import http from './http'

let showLoading = false

//设备列表
export const getDevDevList = data => {
	return http({ method: 'post', url: `/heating/api/dev/devList`, data, showLoading })
}

//设备状态列表
export const getDevStateList = data => {
	return http({ method: 'post', url: `/heating/api/dev/devStateList`, data })
}

// 项目筛选设备信息
export const getDevInfoByProId = data => {
	return http({ method: 'post', url: '/heating/api/dev/devInfoByProId', data })
}
// 设备详情
export const getDevDetails = data => {
	return http({ method: 'post', url: '/heating/api/dev/details', data, showLoading })
}


// 设备详情点位实时数据
export const getDevAttr = deviceIdent => {
	return http({ method: 'get', url: `/heating/api/dev/attr/${deviceIdent}`, showLoading })
}
// 设备属性名称列表
export const getDevAttrName = deviceIdent => {
	return http({ method: 'get', url: `/heating/api/dev/attrName/${deviceIdent}` })
}
// 历史数据
export const getDevHisData = data => {
	return http({ method: 'post', url: '/heating/api/dev/hisData', data, showLoading })
}
// 历史数据 showLoading
export const getDevHisDataLoading = data => {
	return http({ method: 'post', url: '/heating/api/dev/hisData', data })
}
// 设备类型
export const getDevTypeList = () => {
	return http({ method: 'get', url: '/heating/api/dev/devTypeList', })
}
// 新增设备
export const getInsertDev = data => {
	return http({ method: 'post', url: '/heating/api/dev/insertDev', data })
}
// 修改设备
export const getUpdateDev = data => {
	return http({ method: 'put', url: '/heating/api/dev/updateDev', data })
}
// 删除设备
export const getDelDev = id => {
	return http({ method: 'delete', url: `/heating/api/dev/delDev/${id}` })
}

// 回显图片
export const getDevByDevId = id => {
	return http({ method: 'get', url: `/heating/api/dev/byDevId/${id}` })
}

// 删除图片
export const getCommDel = id => {
	return http({ method: 'get', url: `/manager/api/comm/del/${id}` })
}

// 获取设备状态
export const getDeviceState = data => {
	return http({ method: 'post', url: `/heating/api/dev/devStateList`, data, showLoading })
}

//设备导出
export const getDevExport = data => {
	return http({ method: 'post', url: '/heating/api/dev/devExport', data, imgUrl: true })
}

//设备历史数据导出
export const getDevHisExport = data => {
	return http({ method: 'post', url: '/heating/api/dev/devHisExport', data, imgUrl: true })
}
